export const CURRENT_LANGUAGE_FIELD = 'current-language'
export const TOKEN_FIELD = 'auth-token'